import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ItemPipe } from './pipes/item.pipe';
import { NgModule } from '@angular/core';
import { OffClickDirective } from './directives/off-click.directive';
import { TreeSelectComponent } from './components/tree-select.component';
import { TreeSelectDefaultOptions } from './models/tree-select-default-options';
import { TreeSelectItemComponent } from './components/tree-select-item.component';
var NgxTreeSelectModule = /** @class */ (function () {
    function NgxTreeSelectModule() {
    }
    /**
     * @param {?} options
     * @return {?}
     */
    NgxTreeSelectModule.forRoot = function (options) {
        return {
            ngModule: NgxTreeSelectModule,
            providers: [
                { provide: TreeSelectDefaultOptions, useValue: options }
            ]
        };
    };
    NgxTreeSelectModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule
                    ],
                    declarations: [
                        TreeSelectComponent,
                        TreeSelectItemComponent,
                        OffClickDirective,
                        ItemPipe
                    ],
                    exports: [
                        TreeSelectComponent
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    NgxTreeSelectModule.ctorParameters = function () { return []; };
    return NgxTreeSelectModule;
}());
export { NgxTreeSelectModule };
function NgxTreeSelectModule_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxTreeSelectModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgxTreeSelectModule.ctorParameters;
}
//# sourceMappingURL=module.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/custom-tree-select/src/module.js
// module id = 469
// module chunks = 0